import React, { FC } from "react";
import { Space } from "antd";
import { Form, Formik, Field } from "formik";
import { Button, Container, Label, Col } from "../../../styles";
import { Row } from "antd";
import { CreditorFilterValues, ICreditorFilter } from "../../type";

export const CreditorFilter: FC<ICreditorFilter> = ({ getFilters }) => {
  const initialValues: CreditorFilterValues = {
    documentNumber: "",
  };

  return (
    <Container style={{ padding: "0px" }}>
      <Row>
        <Label>Filtrar por:</Label>
      </Row>

      <Formik
        initialValues={initialValues}
        onSubmit={(values) => getFilters(values)}
      >
        <Form>
          <Row gutter={16} align="middle">
            <Col>
              <Field
                type="text"
                name="documentNumber"
                placeholder="Documento"
              />
            </Col>

            <Col>
              <Button htmlType="submit" style={{ marginLeft: "16px" }}>
                Consultar
              </Button>
            </Col>
          </Row>
        </Form>
      </Formik>
    </Container>
  );
};
